var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "v-scroll__bar",
        _vm.direct === "y" ? "is-vertical" : "is-horizontal",
        { active: _vm.isDragging },
      ],
      style: _vm.barStyle,
      on: { mousedown: _vm.barClick },
    },
    [
      _c("div", {
        ref: "slider",
        staticClass: "v-scroll__bar__slider",
        style: _vm.style,
        on: { mousedown: _vm.mousedown },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }